// Компонент - индикатор загрузки

type LoaderProps = {
    opacity?: string,
}

export function Loader({ opacity }: LoaderProps) {
    return (
        <>
            <div className="loader-overlay" style={{ opacity }}>
                <div className="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
            </div>
        </>
    );
}


